import NumberFormat from "react-number-format";
import React, { useState, useEffect } from "react"


const InputMask = (props) => {

    const [mask, setMask] = useState("");
    const [maskValues] = useState({
        ssn: "###-##-####",
        number: "###-###-####",
        zipCode: "######",
        bin : "######"
    });

    const setMaskHandleChange = async (maskValue) => {
        setMask(maskValues[maskValue]);
    }

    useEffect(() => {
        setMaskHandleChange(props.pattern);
    })

    // useEffect(() => {
    //     setMaskHandleChange(props.pattern);
    // }, [props.value])

    return (

        <NumberFormat
            id={props.id}
            name={props.name}
            className={props.className}
            value={props.value}
            format={mask}
            placeholder={props.placeholder}
            onChange={props.handleChange}
            onBlur={props.onBlur}
        />

    )
}
export default InputMask;